<template lang="pug">
  CommonSection(title="Участники проекта" :back="{ title: project.name, name: 'project-stages', params: { projectId: $route.params.projectId } }")
    .b-project-members-page(v-if="project")
      ProjectMembers
      ProjectMembersDescTile._desc
      FormBlock(mobile)
        InvitationsTile(:items="project.invitations" :project="project" @reload="loadData")
      ProjectInvitationsDescTile._desc
</template>

<script>
import Access from '@/utils/access';

import FormBlock from '@/components/FormBlock.vue';
import CommonSection from '@/components/CommonSection.vue';
import InvitationsTile from '@/components/invitation/InvitationsTile.vue';
import ProjectMembers from '@/components/ProjectMembers.vue';
import ProjectMembersDescTile from '@/components/project/ProjectMembersDescTile.vue';
import ProjectInvitationsDescTile from '@/components/project/ProjectInvitationsDescTile.vue';

export default {
  name: 'ProjectMembersPage',
  components: {
    FormBlock,
    CommonSection,
    InvitationsTile,
    ProjectMembers,
    ProjectMembersDescTile,
    ProjectInvitationsDescTile,
  },
  computed: {
    project() { return this.$store.state.project.project; },
  },
  watch: {
    project: {
      immediate: true,
      handler(val) {
        if (!this.project) return;
        const access = new Access(val, this.$store.state.auth.user);

        const hasAccess = access.isProjectAdmin() || access.isProjectAuthor();
        if (!hasAccess) {
          this.$store.commit('error/add', { status: 403 });
        }
      },
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      const { projectId } = this.$route.params;
      this.$store.dispatch('project/fetchProject', { projectId });
    },
  },
};
</script>

<style scoped lang="scss">
  .project-members-page {
    display: grid;
    grid-template-columns: 7fr 3fr;
    gap: 38px;
    align-items: start;

    &__desc {
      grid-column: 2;
    }

    @media (max-width: 1500px) {
      grid-template-columns: 6fr 2fr;
    }

    @media (max-width: 1200px) {
      grid-template-columns: 1fr;

      &__desc {
        grid-column: 1;
      }
    }
  }
</style>
